import React from "react";
import { useTranslation } from "react-i18next";
import ButtonHapticWrapper from "component/Button/ButtonHapticWrapper";
import Tooltip from "component/Tooltip";

type ToggleStartButtonProps = {
    disabled: boolean;
    isCountdown: boolean;
    onToggle: () => void;
};

const BUTTON_CLASS = "game-btn rounded-[60px] cursor-pointer flex items-center justify-center gap-3 w-40 h-14";

const ToggleStartButton = ({ disabled, isCountdown, onToggle }: ToggleStartButtonProps) => {
    const { t } = useTranslation();
    const tooltipText = disabled ? t("lobby.waiting_players_to_start") : isCountdown ? t("lobby.cancel_start") : t("lobby.host_ready_to_start");

    return (
        <Tooltip
            text={tooltipText}            placement="top"
        >
            <ButtonHapticWrapper>
                {isCountdown ? (
                    <button
                        onClick={onToggle}
                        className={`${BUTTON_CLASS} grayscale opacity-70 hover:opacity-90 transition-opacity duration-200`}
                    >
                        <svg className="relative z-10 w-4 h-4 fill-[#195b00]" viewBox="0 0 25 25">
                            <path d="M487.148,1053.48 L492.813,1047.82 C494.376,1046.26 494.376,1043.72 492.813,1042.16 C491.248,1040.59 488.712,1040.59 487.148,1042.16 L481.484,1047.82 L475.82,1042.16 C474.257,1040.59 471.721,1040.59 470.156,1042.16 C468.593,1043.72 468.593,1046.26 470.156,1047.82 L475.82,1053.48 L470.156,1059.15 C468.593,1060.71 468.593,1063.25 470.156,1064.81 C471.721,1066.38 474.257,1066.38 475.82,1064.81 L481.484,1059.15 L487.148,1064.81 C488.712,1066.38 491.248,1066.38 492.813,1064.81 C494.376,1063.25 494.376,1060.71 492.813,1059.15 L487.148,1053.48" transform="translate(-469, -1041)" />
                        </svg>
                    </button>
                ) : (
                    <button
                        onClick={disabled ? undefined : onToggle}
                        className={`${BUTTON_CLASS} ${disabled ? "opacity-40 cursor-not-allowed" : "hover:brightness-110 hover:shadow-[0_0_20px_rgba(100,255,50,0.4)]"}`}
                    >
                        <span className="relative z-10 font-changa-one text-lg lg:text-xl text-[#195b00] uppercase">{t("lobby.start_game")}</span>
                        <svg className="relative z-10 w-3 h-3 lg:w-3.5 lg:h-3.5 fill-[#195b00]" viewBox="291 3606 6.5 7">
                            <path d="M296.494737,3608.57322 L292.500752,3606.14219 C291.83208,3605.73542 291,3606.25002 291,3607.06891 L291,3611.93095 C291,3612.7509 291.83208,3613.26444 292.500752,3612.85767 L296.494737,3610.42771 C297.168421,3610.01774 297.168421,3608.98319 296.494737,3608.57322" />
                        </svg>
                    </button>
                )}
            </ButtonHapticWrapper>
        </Tooltip>
    );
};

export default ToggleStartButton;
